import type { CommissionDistributionResourceDictionary } from "CommissionDistribution/Translations/ResourceDictionary";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { TranslationResources } from "Infrastructure/Translations/TranslationResource";

export const useCommissionDistributionResource = () =>
	useResource<CommissionDistributionResourceDictionary>(
		TranslationResources.CommissionDistribution,
	);

export const CommissionDistributionResource = Resources.commissionDistribution;
